import { SettingsPage } from "@/components/dashboard/settings-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/settings/")({
	component: RouteComponent
});

function RouteComponent() {
	return <SettingsPage />;
}
